import { useQuery } from '@tanstack/react-query';
import { BannerService, BannerDto } from '@/services/banner.service';
import { useUserInfo } from '@/hooks/useUserInfo';
import { dashboardQueryOptions } from '@/config/react-query.config';

export const useBanners = () => {
  const { user } = useUserInfo();
  const locationId = user?.locationId;
  const franchiseId = user?.franchiseId;

  const { data: banners = [], isLoading, error } = useQuery<BannerDto[]>({
    queryKey: ['banners', locationId, franchiseId],
    queryFn: () => BannerService.getActiveBanners(locationId, franchiseId),
    ...dashboardQueryOptions,
  });

  return { banners, isLoading, error };
};
